import React, { useState, useEffect } from 'react';
import { Play, Pause, Volume2, VolumeX, Radio as RadioIcon } from 'lucide-react';
import { useRadio } from '../contexts/RadioContext';

const RadioBar = () => {
  const {
    radioEnabled,
    currentRadioTrack,
    isRadioPlaying,
    radioMuted,
    showTuneInPrompt,
    toggleRadioPlay,
    toggleRadioMute
  } = useRadio();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Don't render if radio is disabled by admin
  if (!radioEnabled || !currentRadioTrack) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-[#0D0D0D] border-b border-[#D4AF37]/20">
      <div className="max-w-7xl mx-auto px-4 py-2">
        <div className="flex items-center justify-between gap-4">
          {/* Radio Label & Track Info */}
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <div className="flex items-center gap-2 flex-shrink-0">
              <RadioIcon size={16} className="text-[#D4AF37]" />
              <span className="text-xs font-['Bebas_Neue'] tracking-wider text-[#D4AF37] uppercase">
                Young Black Man Inc. Radio
              </span>
            </div>
            
            {/* Currently Playing */}
            <div className="hidden md:flex items-center gap-2 min-w-0">
              <span className="text-xs text-[#737373]">•</span>
              <span className="text-xs text-white/80 truncate">
                {currentRadioTrack.title}
              </span>
            </div>
          </div>

          {/* Mobile: Tap to Tune In Prompt */}
          {isMobile && showTuneInPrompt && (
            <button
              onClick={toggleRadioPlay}
              className="px-4 py-1 bg-[#D4AF37] text-black text-xs font-medium uppercase tracking-wider hover:bg-[#E5C048] transition-colors animate-pulse"
            >
              Tap to Tune In
            </button>
          )}

          {/* Controls (visible when prompt is hidden or on desktop) */}
          {(!showTuneInPrompt || !isMobile) && (
            <div className="flex items-center gap-2">
              {/* Play/Pause */}
              <button
                onClick={toggleRadioPlay}
                className="p-1.5 text-[#D4AF37] hover:text-[#E5C048] transition-colors"
                title={isRadioPlaying ? 'Pause Radio' : 'Play Radio'}
              >
                {isRadioPlaying ? <Pause size={18} /> : <Play size={18} />}
              </button>

              {/* Mute/Unmute */}
              <button
                onClick={toggleRadioMute}
                className="p-1.5 text-[#D4AF37] hover:text-[#E5C048] transition-colors"
                title={radioMuted ? 'Unmute Radio' : 'Mute Radio'}
              >
                {radioMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
              </button>

              {/* Live Indicator */}
              {isRadioPlaying && (
                <div className="flex items-center gap-1 ml-2">
                  <div className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" />
                  <span className="text-xs text-[#D4AF37] uppercase tracking-wider hidden sm:inline">
                    Live
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RadioBar;
